import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import Tooltip from '../../../Shared/Tooltip/Tooltip';
import radioChecked from './images/radio-checked.svg';

const Subscribers = (props) => {
    const [subscribers, setSubscribers] = useState([]);
    const [subscriber, setSubscriber] = useState(null);
    const [subscriberName, setSubscriberName] = useState('');
    const [subscriberError, setSubscriberError] = useState('');

    const title = props.options?.title ? props.options?.title : 'ראינו שיש לך כמה מנויי אינטרנט';
    const subTitle = props.options?.subTitle ? props.options?.subTitle : 'עם איזה מנוי נמשיך?';
    const buttonText = props.options?.buttonText ? props.options?.buttonText : 'המשך';

    useEffect(() => {
        async function getSubscribers() {
            let subscribers = [];
            try {
                props.showAppLoader();
                const saleType = props.saleType;
                const result = await ProviderManager.getProviderData('getSubscribers', [saleType]);
                subscribers = result?.Body?.subscribers;
                setSubscriberName(result?.Body?.subscriberName);
            } catch (error) {
                if (error.toString().includes('401')) { return; }
                props.onSelectSubscriber(null);
            } finally {
                props.hideAppLoader();
            }

            //------ if select subsciber on selfcare lobby ------
            if (props.selectedSubscriber) {
                const selectedSubscriber = subscribers.find(x => x.subscriberNo == props.selectedSubscriber);
                if (selectedSubscriber) {
                    props.onSelectSubscriber(selectedSubscriber);
                    return;
                }
            }
            //------ if select subsciber on selfcare lobby ------

            if (subscribers.length > 0) {
                if (subscribers.length == 1) {
                    props.onSelectSubscriber(subscribers[0]);
                }
                else {
                    setSubscribers(subscribers);
                }
            }
            else {
                props.onSelectSubscriber(null);
            }
        }
        getSubscribers();
    }, []);

    if (!subscribers || subscribers.length == 0) { return null; }

    return (
        <div className='subscriber-page'>

            <div className='page-title' dangerouslySetInnerHTML={{ __html: title }}></div>
            <div className='page-sub-title'> {subTitle} </div>

            <div className='subscriber-list-wrapper'>

                {
                    subscribers.map((item, index) => {
                        return (
                            <div className='subscriber' key={index}>
                                <input type='radio' id={`radio-subscriber-${index}`} name='subscriber' onChange={() => handleOnSubscriberClick(item)} />
                                <label htmlFor={`radio-subscriber-${index}`}>
                                    <div className='radio-icon' style={{ '--radio-checked-icon': radioChecked.bg() }}></div>
                                    <div className='details'>
                                        <div className='service-wrapper'>
                                            <div className='service'>
                                                {
                                                    props.saleType == 'energy' &&
                                                    <>
                                                        <a href='#' className='info-link' id={`tooltip-info-${index}`} onClick={(e) => e.preventDefault()}></a>
                                                        <Tooltip text={getTooltipText(item)} target={`tooltip-info-${index}`} placement={'bottom'} cellcomdefault={true} />
                                                    </>
                                                }
                                                {props.saleType == 'energy' ? item.socBillDescription : item.productDescription}
                                            </div>
                                            {
                                                props.saleType == 'energy' &&
                                                <div className='service-tag'> <span className='wifi-icon'></span> <span className='service-tag-text'>{getProductDescription(item) == 'SMART' ? 'מונה חכם': 'מונה בסיסי'}</span> </div>
                                            }
                                        </div>
                                        {
                                            props.saleType == 'energy' && subscriberName &&
                                            <div className='user-full-name'> מנוי {subscriberName} </div>
                                        }
                                        <div className='address'> {item.address.fullAddress} </div>
                                        {
                                            props.saleType == 'energy' &&
                                            <div className='counter-number'> מספר מונה: {getCounterNumber(item)} </div>
                                        }
                                    </div>
                                </label>
                            </div>
                        );
                    })
                }

            </div>

            <div className='button-wrapper'>
                {subscriberError && <div className='error-not-selected'>{subscriberError}</div>}
                <BtnSubmit
                    isBusiness={false}
                    text={buttonText}
                    onclick={handleOnSelectSubscriber}
                    formid='subscriber-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}

                />
            </div>

        </div>
    );

    function getTooltipText(item) {
        const htmlString = `
            <div class='package-info-tooltip'>
                <div> ${item.socBillDescription} </div>
                ${item.planDetails ? `<div class='tooltip-bold-text'> ${item.planDetails} </div>` : ''}
            </div>
        `;
        return htmlString;
    }

    function getProductDescription(item) {
        const product = item.equipments.find(x=> x.productSaleType == 'Energy');
        return product?.productDescription;
    }

    function getCounterNumber(item) {
        const product = item.equipments.find(x=> x.productSaleType == 'Energy');
        return product?.productId;
    }

    function handleOnSubscriberClick(item) {
        setSubscriber(item);
        setSubscriberError('');
    }

    function handleOnSelectSubscriber() {
        if (!subscriber) {

            setSubscriberError(props.saleType == 'energy' ? 'לשינוי התוכנית יש לבחור מונה' : 'להמשך, אנא בחר מנוי');
            return;
        }
        props.onSelectSubscriber(subscriber);
    }
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscribers);
